<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
    
      <span>
        <mat-form-field matTooltip="Business Unit Id" [matTooltipDisabled]="disabledTooltip(this.buId)">
          <mat-label i18n="@@type.BusinessUnit.buId">Business Unit Id</mat-label>
          <input matInput formControlName="buId" id="buId"              
              (ngModelChange)="buIdChanging($event)" [(ngModel)]="item.buId"              
              (ngModelChange)="buIdChanged($event)" #buId              
              maxlength="6" placeholder="Business Unit Id">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)">
          <mat-label i18n="@@type.BusinessUnit.name">Name</mat-label>
          <input matInput formControlName="name" id="name"              
              (ngModelChange)="nameChanging($event)" [(ngModel)]="item.name"              
              (ngModelChange)="nameChanged($event)" #name              
              maxlength="40" placeholder="Name">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Acronym" [matTooltipDisabled]="disabledTooltip(this.acronym)">
          <mat-label i18n="@@type.BusinessUnit.acronym">Acronym</mat-label>
          <input matInput formControlName="acronym" id="acronym"              
              (ngModelChange)="acronymChanging($event)" [(ngModel)]="item.acronym"              
              (ngModelChange)="acronymChanged($event)" #acronym              
              maxlength="6" placeholder="Acronym">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Type from the list" [matTooltipDisabled]="disabledTooltip(this.type)">
          <mat-label i18n="@@type.BusinessUnit.type">Type</mat-label>
          <mat-select formControlName="type" id="type"              
              (ngModelChange)="typeChanging($event)" [(ngModel)]="item.type"              
              (ngModelChange)="typeChanged($event)" #type              
              placeholder="Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let type of typeSelectionList" [value]="type.code">
              {{type.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="closed" id="closed"              
              (ngModelChange)="closedChanging($event)" [(ngModel)]="item.closed"              
              (ngModelChange)="closedChanged($event)" #closed i18n="@@type.BusinessUnit.closed">
Closed          </mat-slide-toggle>        
        </span>
      </span>

    </div>
  
  </form>
</div>